import { render, staticRenderFns } from "./CompanyInfoTotal.vue?vue&type=template&id=bc58629a&scoped=true&"
import script from "./CompanyInfoTotal.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58629a",
  null
  
)

export default component.exports